export const HEADING = "Let's confirm some details about your policy";
